import React from 'react';
import './_index.scss';
import { reducerActions } from './utils';
import CapIcon from '../CapIcon';

const L1ModuleIcon = ({ moduleObj, currentState, dispatchAction }) => {
  const { name, disabled = false, icon, isDisabled, _id } = moduleObj || {};
  const itemSelected = _id ? _id === currentState.selectedL1Module?._id : name === currentState.selectedL1Module?.name;
  const itemHovered = name === currentState.hoveredL1Module?.name;
  return (
    <CapIcon
      type={icon}
      className={`l1-module-icon ${disabled || isDisabled ? 'nav-item-disabled' : ''} ${itemSelected ? 'itemSelected' : ''
        } ${!itemSelected && itemHovered && (!disabled && !isDisabled) ? 'itemHovered' : ''}`}
      // onMouseEnter={() =>
      //   !isDisabled &&
      //   dispatchAction({
      //     type: reducerActions.hoveredL1Module,
      //     value: moduleObj,
      //   })
      // }
    />
  );
};

export default L1ModuleIcon;